import axios from 'axios'
import mutations from '@/store/mutation-types'
import actions from '@/store/action-types'

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

export default {
  state: {
    joinedGroup: false,
    groupList: [],
    person: {
      mine: {
        icon: '',
        name: '',
        duration: 0,
        ranking: 0
      },
      leaderboards: []
    },
    group: {
      mine: {
        icon: '',
        name: '',
        duration: 0,
        ranking: 0
      },
      leaderboards: []
    }
  },
  getters: {
    groupList: state => {
      const groups = {}
      for (let index in ALPHABET) {
        let letter = ALPHABET[index]
        state.groupList.forEach(item => {
          if (item.letter.toUpperCase() === letter) {
            if (!(letter in groups)) {
              groups[letter] = []
            }
            groups[letter].push(item)
          }
        })
      }
      return groups
    }
  },
  mutations: {
    [ mutations.update.PERSON_LEADERBOARD ] (state, payload) {
      state.person.mine = payload.mine
      state.person.leaderboards = payload.leaderboards
    },
    [ mutations.update.GROUP_LEADERBOARD ] (state, payload) {
      state.group.mine = payload.mine
      state.group.leaderboards = payload.leaderboards
    },
    [ mutations.update.GROUP_LIST ] (state, groups) {
      state.groupList = groups
    },
    [ mutations.update.GROUP_JOINED_STATUS ] (state, status) {
      state.joinedGroup = status
    }
  },
  actions: {
    [ actions.fetch.PERSON_LEADERBOARD ] ({ commit, rootState }) {
      return axios.get(`${rootState.API_BASE_URL}/leaderboard`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        if (data) {
          commit(mutations.update.PERSON_LEADERBOARD, data)
        }
      }).catch(error => {
        console.log(`${actions.fetch.PERSON_LEADERBOARD}: ${error}`)
      })
    },
    [ actions.fetch.GROUP_LEADERBOARD ] ({ commit, rootState }) {
      return axios.get(`${rootState.API_BASE_URL}/leaderboard/groups`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        if (data) {
          commit(mutations.update.GROUP_LEADERBOARD, data)
          commit(mutations.update.GROUP_JOINED_STATUS, true)
        } else {
          commit(mutations.update.GROUP_JOINED_STATUS, false)
        }
      }).catch(error => {
        console.log(`${actions.fetch.GROUP_LEADERBOARD}: ${error}`)
      })
    },
    [ actions.post.JOININ_GROUP ] ({ dispatch, rootState }, payload) {
      return axios.post(`${rootState.API_BASE_URL}/groups/join`, {
        ...rootState.urlParams,
        group_id: payload.id
      }).then(({ data }) => {
        if (data.success) {
          dispatch(actions.fetch.GROUP_LEADERBOARD)
        }
      }).catch(error => {
        console.log(`${actions.post.JOININ_GROUP}: ${error}`)
      })
    },
    [ actions.fetch.GROUP_LIST ] ({ commit, rootState }) {
      return axios.get(`${rootState.API_BASE_URL}/groups`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        commit(mutations.update.GROUP_LIST, data.groups)
      }).catch(error => {
        console.log(`${actions.fetch.GROUP_LIST}: ${error}`)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/leaderboard.js